import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

const EmptySearch = (): any => {
  return (
    <Wrapper>
      <p>{T('Empty list')}.</p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  padding: 1em 2em;

  p {
    text-align: center;
  }
`;

export default EmptySearch;
